module.exports = __webpack_public_path__ + "static/media/diag03.c5adce73.jpg";